/**
 * formatDatetime
 * Formats date values for the chart
 */
export function formatDatetime(date: unknown): string {
    if (!date) {
        return "";
    }

    return (date as Date).toLocaleString("en-us", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour12: true,
        hour: "2-digit",
        minute: "2-digit",
        timeZone: "utc",
    });
}
